export default "__VITE_ASSET__C3pU3u75__"